const accessSettings = {

    USER_ROLE_LIST: { name: 'User Role', path: '/user-role-list' },
    ADD_USER_ROLE: { name: 'Add User Role', path: '/add-user-role' },
    UPDATE_USER_ROLE: { name: 'Edit User Role', path: '/edit-user-role' },
    DELETE_USER_ROLE: { name: 'Delete User Role', path: '/delete-user-role' },

    MODULE_LIST: { name: 'Module', path: '/module-list' },
    ADD_MODULE: { name: 'Add Module', path: '/add-module' },
    UPDATE_MODULE: { name: 'Edit Module', path: '/edit-module' },
    DELETE_MODULE: { name: 'Delete Module', path: '/delete-module' },

    ACTION_LIST: { name: 'Action', path: '/action-list' },
    ADD_ACTION: { name: 'Add Action', path: '/add-action' },
    UPDATE_ACTION: { name: 'Edit Action', path: '/edit-action' },
    DELETE_ACTION: { name: 'Delete Action', path: '/delete-action' },

    PERMISSION: { name: 'Permission', path: '/permission' },
    COMPANY_PERMISSION: { name: 'Company Permission', path: '/company-permission' },
    USER_PERMISSION: { name: 'User Permission', path: '/user-permission' },
}

export default accessSettings;